<template>
  <v-parallax
    height="100%"
    dark
    src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"
  >
    <div class="cen">
      <h1 class="parallax display-2 font-weight-thin mb-3">Page not found</h1>
      <h1>404</h1>
      <v-btn class="mt-5 pink" large dark v-on:click="goback()">
        <v-icon size="20px">mdi-arrow-left</v-icon>
        <span>Back</span>
      </v-btn>
    </div>
  </v-parallax>
</template>

<script>
export default {
  metaInfo: {
    title: "Teller/404",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "Teller.ng",
        content:
          "Teller.ng provides online payment settlement system which allows instant money transfer, bill payment, and airtime purchases. It’s safe, reliable and most importantly, hassle-free.Teller helps you to pay your electricity, cable, internet and other bills with ease.  For convenient airtime recharge, funds transfer, bills payments. Making your everyday payment simple, safe and secure.",
      },
    ],
  },
  data: () => ({
    gradient: "to top right, rgba(63,81,181, .7), rgba(25,32,72, .7)",
  }),
  methods: {
    goback() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
.cen {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 800px;
}
.pink {
  background-color: #a229a6 !important;
}
</style>
